var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-dialog',{staticClass:"breakword",attrs:{"header":_vm.dialogDocHeader,"items":_vm.docItems},model:{value:(_vm.$_show),callback:function ($$v) {_vm.$_show=$$v},expression:"$_show"}})}
var staticRenderFns = []

export { render, staticRenderFns }